import { Menu } from "antd";
import type { MenuProps } from "antd";

export type UIMenuProps = MenuProps;
export type UIMenuItems = NonNullable<MenuProps["items"]>;
export type UIMenuItemType = UIMenuItems[number];

export const UIMenu = (props: UIMenuProps) => <Menu {...props} />;
